import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";
import { useCallback, useMemo } from "react";

import {
	$completeTemplateOnboarding,
	$templateOnboarding,
} from "../../internal/document/template-onboarding.atom";

export const useTemplateOnboarding = (documentId: string | undefined) => {
	const docId = documentId ?? "";

	const loadableAtom = useMemo(() => loadable($templateOnboarding(docId)), [docId]);
	const loadableState = useAtomValue(loadableAtom);
	const completeOnboarding = useSetAtom($completeTemplateOnboarding);

	const config = loadableState.state === "hasData" ? loadableState.data : null;
	const isLoading = loadableState.state === "loading";

	const prompts = useMemo(() => config?.prompts ?? [], [config?.prompts]);
	const isOnboarding = !!documentId && !isLoading && prompts.length > 0;

	const complete = useCallback(() => {
		if (documentId) {
			completeOnboarding(documentId);
		}
	}, [documentId, completeOnboarding]);

	return {
		prompts,
		isOnboarding,
		isLoading,
		complete,
	};
};
